export default __webpack_public_path__ + "static/media/thumbnail.ac9d019a.png";